"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function FullServiceSolutions() {
  const verticalColumns = [{
    title: "Medical"
  }, {
    title: "Legal"
  }, {
    title: "Translation"
  }];
  return <section data-section-id="235480" id="specialized-verticals" className="bg-white text-foreground py-20 lg:py-24">
      <div className="container mx-auto px-4 md:px-8">
        <div className="mb-14 max-w-4xl">
          <h2 className="font-serif text-5xl md:text-6xl lg:text-7xl text-primary mb-8 leading-[1.1]">
            Bridging Critical Gaps with <br className="hidden md:block" />
            Technical Precision.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-5 mb-14">
          {verticalColumns.map((col, i) => <div key={col.title} data-index={i} className="flex flex-col">
              <h3 className="font-serif text-3xl md:text-4xl lg:text-5xl text-primary border-b border-border pb-6">
                {col.title}
              </h3>
            </div>)}
        </div>

        <div className="flex justify-center">
          <Button asChild size="lg" className="rounded-sm font-mono uppercase tracking-widest px-12 h-14">
            <Link to="/ServicesPage">
              View All Services
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}